import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
  import { ref, watch } from "vue";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emit = __emit;
  const props = __props;
  const currentRoute = ref<string>("");

  function getSectionTitle(path: string): string {
    const section = path.split("/")[2];
    const sectionTitles: Record<string, string> = {
      "project-page": "Project Page",
      "hl-packages": "H&L Packages",
    };

    if (sectionTitles[section]) return sectionTitles[section];

    return section.charAt(0).toUpperCase() + section.slice(1);
  }

  function updateSectionTitle() {
    currentRoute.value = getSectionTitle(router.currentRoute.value.fullPath);
  }

  function toggleBurger() {
    emit("update:modelValue", !props.modelValue);
  }

  updateSectionTitle();

  watch(() => router.currentRoute.value.fullPath, updateSectionTitle);

const __returned__ = { emit, props, currentRoute, getSectionTitle, updateSectionTitle, toggleBurger, get router() { return router }, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})